import User from '@/modules/user/pages/user/users.page.vue';
import UserRegister from '@/modules/user/pages/user-register/users-register.page.vue';
import UserBond from '@/modules/user/pages/user-bond/users-bond.page.vue';
import UserBondRegister from '@/modules/user/pages/user-bond-register/users-bond-register.page.vue';

declare const process: any;

export const USER_ACCESS_ROUTES = Object.freeze({
    USER: 'users-route',
    USER_REGISTER: 'users-register',
    USER_BOND: 'users-bond',
    USER_BOND_REGISTER: 'users-bond-register',
});

export const userRoutes = [
    {
        path: `${process.env.BASE_URL}user`,
        component: () => import('@/layout/default.layout.vue'),
        children: [
            {
                path: '',
                component: User,
                meta: {
                    requiresAuth: true,
                },
                children: [
                    {
                        path: '',
                        components: {
                            default: UserRegister,
                            bondlist: UserBond,
                            bondregister: UserBondRegister,
                        },
                    },
                ],
            },
        ],
    },
];
